import { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { CheckCircle, Eye, EyeSlash, XCircle } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Validation from "../../hooks/Validation";
import { resetPassword, forgotPassword } from "../../store/actions/adminAction";
import { adminReset } from "../../store/reducerSlice/admin";
import Loader from "../common/loader/Loader";
import ApiResponsePopup from "../common/modal/ApiResponsePopup";
import Styles from "../Login/LoginForm.module.css";

const formElements = [
  {
    key: "email",
    label: "Email",
    placeHolder: "Enter email",
    type: "text",
  },
];

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const [passwordDetail, setPasswordDetail] = useState({
    email: null,
  });
  const [sentPayload, setSentPayload] = useState(null);
  const [eyes, setEyes] = useState({
    email: false,
  });
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation(passwordDetail);
  const dispatch = useDispatch();
  const {
    adminDetail,
    isLoader,
    isRecordAdded,
    error: apiError,
  } = useSelector((state) => state.admin);

  const submitHandler = (e) => {
    e.preventDefault();
    setSentPayload(null);
    checkValidator();

    if (!isError() && error !== null) {
      dispatch(forgotPassword({ clientEmail: passwordDetail?.email })).then(
        (payload) => {
          if (payload?.payload?.success) {
            setSentPayload(payload?.payload?.message);
          }
        }
      );
    }
  };

  const hideHandlerRes = () => {
    dispatch(adminReset());
    navigate("/");
  };

  useEffect(() => {
    return () => {
      dispatch(adminReset());
    };
  }, []);

  return (
    <Form
      onSubmit={(e) => submitHandler(e)}
      style={{ maxWidth: 600, margin: "0 auto" }}
      noValidate
    >
      <h1 className={`${Styles.h1} mb-3`}>Forgot Password</h1>
      <p className="mb-4 h6 text-center">
        Please enter your registered email here and we’ll send instructions on
        how to reset the password.
      </p>
      {isLoader && <Loader />}
      {apiError && (
        <Alert variant={"danger"}>
          {apiError?.message || "Access denied! Please try again"}
        </Alert>
      )}
      {sentPayload && <Alert variant={"success"}>{sentPayload}</Alert>}
      {formElements.map((element, i) => {
        return (
          <Form.Group
            className="mb-2 rowField"
            controlId="formBasicEmail"
            key={i}
          >
            <Form.Label>
              {element.label} <span className="required">*</span>
            </Form.Label>
            <Form.Control
              type={eyes[element.key] ? "text" : element.type}
              name={element.key}
              placeholder={element.placeHolder}
              value={passwordDetail && passwordDetail[element.key]}
              onChange={(e) => {
                setPasswordDetail({
                  ...passwordDetail,
                  [element.key]: e.target.value,
                });
                // resetValidator(e.target.name);
                //element.key === 'newPassword' &&
                // checkValidator(element.key)
              }}
              onKeyUp={(e) => {
                checkValidator(element.key);
              }}
              isInvalid={
                error &&
                error !== null &&
                typeof error[element.key] !== "object" &&
                error[element.key]
              }
            />
            {element.key !== "email" ? (
              <div
                className="eyeIcon"
                onClick={(e) =>
                  setEyes({
                    ...eyes,
                    [element.key]: !eyes[element.key],
                  })
                }
              >
                {eyes[element.key] ? <Eye /> : <EyeSlash />}
              </div>
            ) : null}
            <Form.Control.Feedback type="invalid">
              {error &&
                error !== null &&
                typeof error[element.key] !== "object" &&
                error[element.key]}
            </Form.Control.Feedback>
          </Form.Group>
        );
      })}
      <Form.Group className="mb-3 align-right" controlId="formBasicPassword">
        <Link to="/">Return to Login</Link>
      </Form.Group>
      {/* <div className="requiredNote mb-2">Note: You must complete all the mandatory fields.</div> */}
      <Button
        variant="default"
        className="btn-primary gd-primary"
        type="submit"
      >
        Reset Password
      </Button>
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordAdded,
          title: "Successfully Sent",
          successMsg: "We have e-mailed your password reset link.",
          updateMsg: "Password successfully updated!",
        }}
      />
    </Form>
  );
};

export default ForgotPasswordForm;
